// Module
var code = `<div class="icon-question-sign help-icon"></div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/common/help.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;